import { useState } from "react";

const items = [
  { href: "#about", label: "About Ace96au" },
  { href: "#security", label: "Security and Licence" },
  { href: "#games", label: "Games" },
  { href: "#sports", label: "Sports Betting" },
  { href: "#bonuses", label: "Bonuses and Promotions" },
  { href: "#payment", label: "Payment Variants" },
  { href: "#payment-guide", label: "Payment Methods Guide & Comparison" },
  { href: "#blog", label: "Ace96au Blog" },
  { href: "#mobile", label: "Mobile Gambling" },
  { href: "#customer", label: "Customer Support" },
  { href: "#conclusion", label: "Conclusion" },
  { href: "#faq", label: "FAQ" },
];

export default function TableOfContents() {
  const [open, setOpen] = useState(true);

  return (
    <section className="glass-card rounded-2xl p-6 my-10">
      <div className="flex items-center justify-between mb-4">
        <h2
          className="gradient-text font-bold text-lg tracking-widest uppercase"
          style={{ fontFamily: "'Cinzel', serif" }}
        >
          Contents
        </h2>
        <button
          onClick={() => setOpen(!open)}
          className="btn-glow w-8 h-8 rounded-lg flex items-center justify-center cursor-pointer text-sm"
          aria-label="Toggle"
        >
          <span><i className={open ? "ri-subtract-line" : "ri-add-line"}></i></span>
        </button>
      </div>
      {open && (
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {items.map((item, i) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-slate-300 transition-all duration-200 group cursor-pointer hover:text-blue-400"
                style={{ background: "rgba(255,255,255,0.02)" }}
                onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.background = "rgba(16,92,232,0.1)"}
                onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.background = "rgba(255,255,255,0.02)"}
              >
                <span
                  className="w-5 h-5 flex items-center justify-center rounded text-xs font-bold flex-shrink-0"
                  style={{
                    background: "linear-gradient(135deg, rgba(16,92,232,0.25), rgba(16,92,232,0.15))",
                    color: "#105CE8",
                    border: "1px solid rgba(16,92,232,0.3)",
                  }}
                >
                  {i + 1}
                </span>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
